<template>
  <section class="banner" v-if="banner">
    <div class="wrapper">
      <div class="banner__inner">
        <component :is="banner"></component>
      </div>
    </div>
  </section>
</template>

<script>
import {
  CommonBanner,
  ProjectBanner,
  NewsBanner,
  PostBanner,
  VolunteersBanner,
  MobileBanner,
  SerafimBanner
} from "@/components/app/Banners";

export default {
  name: "Banner",
  computed: {
    banner() {
      return this.$route.meta.description.banner;
    }
  },
  components: {
    CommonBanner,
    ProjectBanner,
    NewsBanner,
    PostBanner,
    VolunteersBanner,
    MobileBanner,
    SerafimBanner
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

/*<banner>*/
.banner {
  &__inner {
    padding: 40px 0;
  }

  &__layout {
    background-color: $sec_bg;
    box-shadow: 0 0 2.5px 1px rgba($color: #000, $alpha: 0.1);
  }

  &__text {
    margin: 10px 0;
    word-break: break-all;
  }

  h1,
  h2 {
    line-height: 1.1;
  }

  @media screen and (min-width: $min-lg) {
    &__layout {
      padding: 45px;
      border-radius: 30px;
    }
  }

  @media screen and (max-width: $max-md) {
    &__layout {
      padding: 40px 30px;
      border-radius: 15px;

      & > div:first-child {
        margin: 0 0 30px;
      }
    }
  }
}
</style>
